import { Directive } from 'angular-ts-decorators';

/**
 * Directive to auto focus an element if the condition is true on load
 */
@Directive({
  selector: '[sw-autofocus]',
})
export class SwAutofocusDirective {
  constructor(
    private $element: ng.IAugmentedJQuery,
    private $scope,
    private $attrs,
    private $timeout: ng.ITimeoutService,
  ) {
    'ngInject';

    // TODO move to a parent class V6CompatibleDirective
    if (angular.version.minor < 5) {
      this.$timeout(() => {
        this.ngAfterViewInit();
      });
    }
  }

  ngAfterViewInit() {
    if (this.$attrs.swAutofocus === '') {
      // focus if attribute is present but no value
      this.$element[0].focus();
    } else if (this.$scope.$eval(this.$attrs.swAutofocus)) {
      // use focus function instead of autofocus attribute to avoid cross
      // browser problem. And autofocus should only be used to mark
      // an element to be focused when page loads.
      this.$element[0].focus();
    }
  }
}
